import React from 'react';

const LearnosityFrqTemplate = ({ questionTypeHeading }) => (
  <div type="text/template" data-lrn-qe-layout="frq_1" hidden>
    <h5 className="lrn-qe-heading">Compose {questionTypeHeading} Question</h5>
    <span data-lrn-qe-input="stimulus" className="lrn-qe-ckeditor-lg" />
  </div>
);

export default LearnosityFrqTemplate;
